import { render } from "./opTable.vue?vue&type=template&id=0912c06e&ts=true"
import script from "./opTable.vue?vue&type=script&lang=ts"
export * from "./opTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__